import OcrolusAccordion from "./OcrolusAccordion";

export default OcrolusAccordion;
